<template lang="pug">
.investor_relation
  banner(:banner="investorRelationInformation")
  #sticky-nav
    .container
      b-navbar.p-0(toggleable="lg")
        b-navbar-brand
        b-navbar-toggle(target="nav-collapse")
          //- font-awesome-icon(:icon="['fas', 'exclamation-circle']") 
          MdMenuIcon(w="1.7rem", h="1.7rem")
          //- i.ion-android-menu
        b-collapse#nav-collapse(is-nav="")
          b-navbar-nav
            template
              b-nav-item-dropdown(
                v-for="(category, categoryIndex) in investorRelationCategoryList",
                :text="category.name",
                :key="categoryIndex",
                :ref="category.id",
                @mouseover.native="overCategory(categoryIndex)",
                @mouseleave.native="leaveCategory(categoryIndex)",
                :class="{ active: categorySelectIndex == categoryIndex }"
              )
                b-dropdown-item(
                  v-for="(investorRelation, index) in category.investor_relations",
                  :key="index",
                  @click="investorRelationClick(categoryIndex, investorRelation)"
                ) {{ investorRelation.name }}
  .py-5.bg-light
    .container.magic-ckeditor(v-html="investorRelationSelect.content")
  float-actions
  float-top
  .PCAP-IC-selector.d-block.d-sm-none
    a.shadow-sm(
      v-b-modal.dialog="",
      @click="$bvModal.show('selectorModal')",
      data-toggle="modal",
      data-target="#selectorModal"
    )
      font-awesome-icon.i_mr_1(:icon="['fas', 'search']") 
      | PCAP IC selector
  custom-footer
</template>

<script>
import Footer from "@/components/home/Footer";
import FloatTop from "@/components/common/FloatTop";
import FloatActions from "@/components/common/FloatActions";
import Banner from "@/components/investor_relation/Banner";
import FolderImg from "@/assets/img/download/folder.png";
import MdMenuIcon from "vue-ionicons/dist/md-menu.vue";
import {
  getInvestorRelationInformation,
  getInvestorRelationCategoryList,
} from "@/api/investor_relation";
export default {
  name: "InvestorRelation",
  metaInfo() {
    return {
      title: this.metaData.title,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
        { property: "og:site_name", content: this.metaData.siteTitle },
        {
          property: "og:title",
          content: this.metaData.title,
        },
        {
          property: "og:description",
          content: this.metaData.description,
        },
        { name: "og:url", content: this.metaData.url },
        { name: "og:image", content: this.metaData.image },
        { name: "smo_type", content: this.metaData.smoType },
      ],
    };
  },
  components: {
    "custom-footer": Footer,
    "float-top": FloatTop,
    "float-actions": FloatActions,
    Banner,
    MdMenuIcon,
  },
  data() {
    return {
      investorRelationInformation: {},
      investorRelationCategoryList: [],
      categorySelectIndex: -1,
      investorRelationSelect: {},
      img: {
        folderImg: FolderImg,
      },
      metaData: {
        siteTitle: "",
        title: "",
        description: "",
        keywords: "",
        url: "",
        image: "",
        smoType: "website",
      },
    };
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
    "$route.params.sub_tab_id"() {
      this.getInvestorRelationTab();
    },
  },
  created() {
    this.initialLanguage();
  },
  mounted() {
    this.onResize();
    this.$store.state.screenWidth = document.documentElement.clientWidth;
  },
  methods: {
    initialLanguage() {
      this.getInvestorRelationInformation();
      this.getInvestorRelationCategoryList();
    },
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };
    },
    getInvestorRelationInformation() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getInvestorRelationInformation(temp).then((response) => {
        this.investorRelationInformation = response.data;
      });
    },
    getInvestorRelationCategoryList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getInvestorRelationCategoryList(temp).then((response) => {
        this.investorRelationCategoryList = response.data;
        this.getInvestorRelationTab();
      });
    },
    overCategory(index) {
      if (this.$store.state.screenWidth > 991) {
        this.$refs[this.investorRelationCategoryList[index].id][0].show();
      }
    },
    leaveCategory(index) {
      if (this.$store.state.screenWidth > 991) {
        this.$refs[this.investorRelationCategoryList[index].id][0].hide();
      }
    },
    investorRelationClick(categoryIndex, investorRelation) {
      this.$router.push({
        name: "InvestorRelation",
        params: {
          tab_id: this.investorRelationCategoryList[categoryIndex].id,
          sub_tab_id: investorRelation.id,
        },
      });
    },
    getInvestorRelationTab() {
      let tempInvestorRelationCategory;
      let tempInvestorRelation;
      for (let index in this.investorRelationCategoryList) {
        let temp = this.investorRelationCategoryList[index];
        if (this.$route.params.tab_id == temp.id) {
          this.categorySelectIndex = index;
          tempInvestorRelationCategory = temp;
          break;
        }
      }

      for (let index in tempInvestorRelationCategory.investor_relations) {
        let temp = tempInvestorRelationCategory.investor_relations[index];
        if (this.$route.params.sub_tab_id == temp.id) {
          tempInvestorRelation = temp;
          break;
        }
      }

      this.investorRelationSelect = tempInvestorRelation;
      this.metaData.siteTitle = tempInvestorRelation.seo_og_site_name
        ? tempInvestorRelation.seo_og_site_name
        : "";
      this.metaData.title = tempInvestorRelation.seo_og_title
        ? tempInvestorRelation.seo_og_title
        : "";
      this.metaData.description = tempInvestorRelation.seo_description
        ? tempInvestorRelation.seo_description
        : "";
      this.metaData.keywords = tempInvestorRelation.seo_keywords
        ? tempInvestorRelation.seo_keywords
        : "";
      this.metaData.url = tempInvestorRelation.seo_og_url
        ? tempInvestorRelation.seo_og_url
        : "";
      this.metaData.image = tempInvestorRelation.seo_og_image
        ? tempInvestorRelation.seo_og_image.image
        : "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/navbar";
@import "@/assets/style/common/table";
</style>

<style lang="scss">
@import "@/assets/style/common/magic_ckeditor";

table {
  width: 100%;
}
.table th {
  background-color: rgba(1, 51, 143, 0.1);
  padding: 0.5rem;
  vertical-align: bottom;
}

.folder-icon {
  display: inline-block;
  width: 30px;
  font-size: 0.75rem;
  line-height: 1;
  text-decoration: none !important;
  text-transform: uppercase;
  text-align: center;
}
</style>
